const env = UMI_ENV;

//  第三方的oauth2不支持在web开发工具调试，该工具本身仅能调试自己企业内的应用
//  第三方应用兼容处理的2个方案;

//  1.采用客户端调试https://work.weixin.qq.com/api/doc#90001/90148/90457

//  2.企业内部自建应用模式，配置的域名与对应的第三方应用一致，修改oauth2 appid=corpid，调用接口https://work.weixin.qq.com/api/doc#90000/90135/91020做兼容修改，来进行调用，走企业内部授权，页面测试完成之后，再切换成对应的第三方应用接口

export const TOKEN = `${env}-dyj-token`;
export const AVATAR = 'https://rescdn.qqmail.com/node/wwmng/wwmng/style/images/independent/DefaultAvatar$73ba92b5.png'

// 第三方应用id（即ww或wx开头的suite_id）。注意与企业的网页授权登录不同
// 服务商的CorpID
// export const SuiteID = env === 'dev' ? 'wwb6994f6c365d503d' : 'wwb6994f6c365d503d';
// export const ThridCorpID = env === 'dev' ? 'ww84332616507d83b8' : 'ww84332616507d83b8';

// ds
// export const LoginSuiteID = 'wwdd718701a2b6a8b4';
// export const SuiteID = 'ww80b6e12b421f35a8';
// export const ThridCorpID = 'ww5a223631b210ae44';

// dqm
export const LoginSuiteID = 'ww425fe671cebe2aec';
export const SuiteID = 'ww9adb7b68aa8889f0';
export const ThridCorpID = 'ww8ce854e90890f767';
